import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				close: "closeSearch",
				reset: "resetSearch",
			},
			input: {
				input: "input",
			},
		};

		this.isOpen = false;
	}

	init() {
		this.$input = this.$("input")[0];
		this.$resultsContainer = this.$("results")[0];

		this.observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.attributeName === "aria-expanded" && mutation.oldValue === "false") {
					const newValue = mutation.target.getAttribute("aria-expanded");

					if (newValue === "true") {
						// aria-expanded changed from false to true, meaning results are likely visible
						// this.updatePostCount();
					}
				}
			});
		});

		this.observer.observe(this.$resultsContainer, {
			attributes: true,
			subtree: true,
			attributeFilter: ["aria-expanded"],
			attributeOldValue: true,
		});

		this.$input.addEventListener("input", () => {
			if (this.$input.value.length > 3) {
				// this.updatePostCount();
			}
		});

		this.lenis = window.prtx.lenisInstance;
		this.handleScroll = this.onScroll.bind(this);

		this.initEvents();
	}

	onScroll({ velocity }) {
		if (Math.abs(velocity) > 2 && this.isOpen) {
			this.closeSearch();
		}
	}

	initEvents() {
		this.lenis.on("scroll", this.handleScroll);
	}

	updatePostCount() {
		const postElements = this.$resultsContainer.querySelectorAll(".c-search-result");
		const postCount = postElements.length;

		this.$("count")[0].textContent = `${postCount} résultats`;
	}

	openSearch() {
		this.el.classList.toggle("is-active");
		this.isOpen = true;

		this.call("closeMenu", "header");
	}

	closeSearch() {
		this.el.classList.remove("is-active");
		this.isOpen = false;
	}

	resetSearch() {
		this.$input.value = "";
	}

	input() {
		if (this.$input.value.length >= 3) {
			this.loaded = false;
		}
	}

	destroy() {}
}
